import typography from '../typography';

const MuiFormHelperText = {
  root: {
    ...typography.subtitle1
  }
};

export default MuiFormHelperText;